/*******************************************************************
* PAGE        : URL
* REMARKS     : Comman URL file
* CREATED ON  : 19-12-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

const domain = window.location.origin;
const globalUrl = process.env.REACT_APP_API_URL;
const aiGlobalUrl = process.env.REACT_APP_AI_API_URL;
// const mapGlobalKay = process.env.REACT_APP_GOOGLE_MAP_KEY;

export const URL = () => {
    return window.APP_CONFIG.API_URL;

    // const url = "http://localhost:8123/";
    // http://43.230.202.252/
    // const url = globalUrl;
    // return url;
}

export const AIURL = () => {
    return window.APP_CONFIG.AI_API_URL;

    // const url = aiGlobalUrl;
    // return aiGlobalUrl;
}

// export const googlekey = "AIzaSyDA6zGJ5b1TWflFEztgk66aJdeKr1BP8Ns";
// export const googlekey = "AIzaSyADuqBLc9zohAVpDxra-okf4nbFvBms3sU";
export const googlekey = "AIzaSyC800V2crKrdwQfDrWTvEaubR5AcPgDJjw";
export const AESKey = "1234567890abcdef1234567890abcdef";
// export const googlekey = mapGlobalKay;
// export const googlekey = window.APP_CONFIG.GOOGLE_MAP_KEY;;
// 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
